import React, { useEffect, useState } from 'react'

import "./RenderImageOverlay.css"
import "./RenderImageOverlayForBackground.css"

import { FiDownload } from 'react-icons/fi'


const RenderImageOverlayForBackground = (props) => {



  return (
           (props.index === 0 || props.index === 2) && (
          //  (props.showCaption || props.index === 0 || props.index === 2  || (props.componentFrom === "exploreNext" && props.exploreNextType === "short")) && (
      <div className={`caption-preview image_caption_overlay}`}>
      <div className='w-100 d-flex justify-content-center align-items-center flex-column custom_height'>
    
   <div
      className="saved_badge main_action_button main_save_button image_text_content background_container_tap_message"
    
    // onMouseOut={(e)=> makeButtonOriginal(e)}
    >
      {/* Looks Great on Mobile */}
      {props.index === 0 && 'Perfect for phone wallpaper'}
      {props.index === 2 && 'Perfect for lockscreen'}
      {/* Perfect for phone wallpaper */}
    </div>


        {/* <span className='image_overlay_heading d-flex align-items-center justify-content-center gap-1 '>

        Use Background
 
        </span>
        

        <p>Download Hd Background</p> */}
       
        <button className={`mt-2 image_overlay_tap_button related_interest_image_title download_status_image_button three_dot ${props.exploreNextType === "short" ? `` : ''} donwload_button_new`}>
       {/* Downloaad {props.imageFor.charAt(0).toUpperCase() + props.imageFor.slice(1)}  <FiDownload className="home_seeall_icon"  /> */}
       Tap to Download  <FiDownload className="home_seeall_icon"  />

        </button>

        
        {/* </div> */}
    
      </div>
      </div>
    )
  )
}

export default RenderImageOverlayForBackground


